import type { Signal, SignalId } from "../types/signal";
import type { SignalsGroupedByType } from "../types/signal-collection";

/** Flattens a per-type signal collection into a list of signals. */
export const getSignalsFromGroupedSignals = (
    signalsGroupedByType: Readonly<Partial<SignalsGroupedByType>>,
): readonly Signal[] =>
    Object.values(signalsGroupedByType)
        .flat()
        .filter((signal): signal is Signal => signal?.id !== undefined);

/** Flattens a per-type signal collection into a list of signal IDs. */
export const getSignalIdsFromGroupedSignals = (
    signalsGroupedByType: Readonly<Partial<SignalsGroupedByType>>,
): readonly SignalId[] => getSignalsFromGroupedSignals(signalsGroupedByType).map((signal) => signal.id);
